import { useTimeTransform } from '@hooks/useTimeTransform';
import { PetStatisticsModel } from '@models/Device';
import { getSingleDuration } from '@utils/date';
import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import React, { useMemo } from 'react';
import useBoundStore from 'src/store/store';

import PetInfoSection from './PetInfoSection';

type PetLastActionTime = {
  icon: any;
  data: PetStatisticsModel['drinking'] | PetStatisticsModel['feeding'];
  title: string;
  withTimeMarker?: boolean;
  disablePadding?: boolean;
  rightSideFlexEnd?: boolean;
  viewStyle?: 'normal' | 'compact' | 'subCompact';
};

const PetLastActionTime = ({
  icon,
  data,
  title,
  withTimeMarker = true,
  disablePadding,
  rightSideFlexEnd = false,
  viewStyle = 'normal',
}: PetLastActionTime) => {
  const user = useBoundStore(state => state.accountStore.user);
  const { timeToFormat } = useTimeTransform();

  const activeHousehold = useBoundStore(s => s.householdStore.activeHousehold);

  const [lastDrunkTime, timeMarker] = useMemo(() => {
    if (!data || !data?.last_consumption || +data?.last_consumption > Date.now()  ||
    new Date(data?.last_consumption)?.getFullYear() === 2000) return ['-', '-'];
    const duration = getSingleDuration(data?.last_consumption, true, viewStyle === 'normal');

    const timeMarkerValue = timeToFormat(
      format(
        utcToZonedTime(
          data?.last_consumption,
          activeHousehold?.timezone.timezone.replace('Kolkata', 'Calcutta'),
        ),
        'HH:mm',
      ),
      user.time_format,
    );

    return [duration || '-', timeMarkerValue || '-'];
  }, [data, user.time_format]);

  return (
    <PetInfoSection
      icon={icon}
      fontSizeForNumbers={viewStyle === 'subCompact' ? 18 : 24}
      fontSizeForText={viewStyle === 'subCompact' ? 18 : 16}
      title={title}
      timeMarker={withTimeMarker ? timeMarker : null}
      data={lastDrunkTime}
      disablePadding={disablePadding}
      type="time"
      rightSideFlexEnd={rightSideFlexEnd}
      viewStyle={viewStyle}
    />
  );
};

export default PetLastActionTime;
